export default __webpack_public_path__ + "static/media/vect211.04a17619.png";